import RecipeInfoBase from './RecipeInfoBase';
import RecipeCard from './RecipeCard.vue';

export { RecipeInfoBase, RecipeCard };
